module.exports = __webpack_public_path__ + "img/vue2-renfort_gris.baa6aa8a.png";